import { render } from "./TenantDeployments.vue?vue&type=template&id=13e8471f&ts=true"
import script from "./TenantDeployments.vue?vue&type=script&lang=ts"
export * from "./TenantDeployments.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__